import axios from "axios";

export const axiosDownloadFile = async (url, method = 'GET', requestData = {}, filename = null) => {
  const {data, filename: downloadFilename} = await getBlobFromUrl(url, method, requestData);

  downloadBlob(data, filename ?? downloadFilename);
};

const getBlobFromUrl = async (url, method = 'GET', requestData = {}) => {
  const {data, headers} = await axios.request({
    url,
    method,
    data: requestData,
    responseType: "blob"
  });

  const filename = getFilenameFromHeaders(headers);

  return {
    data,
    filename,
  };
};

const getFilenameFromHeaders = (headers) => {
  const contentDisposition = headers['content-disposition'];
  let filename = 'download.csv';
  if (contentDisposition && contentDisposition.includes('filename=')) {
    const matches = contentDisposition.match(/filename="?(.*)"?/);
    if (matches && matches[1]) {
      filename = matches[1];
    }
  }

  return filename;
};

const downloadBlob = (blob, filename) => {
  const urlObject = URL.createObjectURL(blob);

  const anchor = document.createElement("a");
  anchor.style.display = "none"; // Make it hidden
  anchor.href = urlObject;
  if (filename) {
    anchor.download = filename; // Specify filename for download
  }
  document.body.appendChild(anchor);
  anchor.click();

  document.body.removeChild(anchor);
  URL.revokeObjectURL(urlObject);
};
